import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FirstTableST from "./FirstTableST/FirstTableST";
import SecondTableST from "./SecondTableST/SecondTableST";
import ThirdTableST from "./ThirdTableST/ThirdTableST";
import FourtTableST from "./FourthTableST/FourtTableST";
import FifthTableST from "./FifthTableST/FifthTableST";

const StoSearchTerms = () => {
  // state to track which accordion is expanded
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box p={2}>
      {/* Header */}
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="left"
        padding="8px"
      >
        <Typography variant="h5">Anomalies</Typography>
        <Typography variant="body2" gutterBottom color="text.secondary">
          Identify and resolve account-level anomalies in Negative Search Term
          configurations
        </Typography>
      </Stack>

      {/* Accordion */}
      {/* Preforming Search Terms Without Classification – 59   */}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            minHeight: "48px !important",
          }}
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Preforming Search Terms Without Classification – 59
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Search terms that have generated traffic (impressions, clicks,
            conversions) but do not have a defined classification relative to
            keywords
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FirstTableST />
        </AccordionDetails>
      </Accordion>
      {/* Exclusive Search Terms Missing Cross-Negatives – 10 */}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Exclusive Search Terms Missing Cross-Negatives – 10
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Exclusive search terms that are not defined as negatives in other ad
            groups
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SecondTableST />
        </AccordionDetails>
      </Accordion>
      {/* Contradicting Search Terms Definitions – 3 */}
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Contradicting Search Terms Definitions – 3
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Exclusive/Allowed search terms that are marked as negative in same
            ad group
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ThirdTableST />
        </AccordionDetails>
      </Accordion>
      {/* Identical to exact keyword yet undefined as negative – 5 */}
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Identical to exact keyword yet undefined as negative – 5
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Search terms that matches an exact keyword and are not defined as a
            negative in other ad groups
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FourtTableST />
        </AccordionDetails>
      </Accordion>
      {/* Captured by multiple keywords in different ad groups – 80 */}
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Captured by multiple keywords in different ad groups – 80
          </Typography>
          <Typography component="span" sx={{ color: "text.secondary" }}>
            Search Terms Marked as Allowed, Matched by Multiple Keywords in
            Other Groups
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FifthTableST />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default StoSearchTerms;
